import { Container, Col } from "react-bootstrap";
import navIcon1 from "../assets/img/nav-icon1.svg";
import gith from '../assets/img/git.png'
import navIcon3 from "../assets/img/nav-icon3.svg";


export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
          <Col size={12} sm={12} className="text-center">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/mariano-emmanuel-veron-santos-oliveira-bb791b208/"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://github.com/Maranelo97"><img src={gith} alt="Icon" /></a>
              <a href="https://www.instagram.com/marianoverondamvp97/"><img src={navIcon3} alt="Icon" /></a>
            </div>
            <p>Mariano Verón Santos</p>
            <p>marianoveronsantos@gmail.com</p>
          </Col>
      </Container>
    </footer>
  )
}
